import { forwardRef, useMemo } from 'react';
import PropTypes from 'prop-types';

import { IconGeneralText } from 'src/assets/icons/generationTools/IconGeneralText';
import { ContextMenu } from 'src/components/ContextMenu';
import { CUSTOM_MENU_ITEM_TYPE } from 'src/components/CustomMenuItem';
import { GenerationToolIcon } from 'src/components/GenerationToolIcon';
import {
  getSectionToolsOptions,
  getToolSectionLabel,
  isFreestyleGenerationTool,
} from 'src/data/generationTool';

import { useStyles } from './useStyles';

const MENU_PROPS = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'right',
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'right',
  },
  getContentAnchorEl: null,
};

export const ContextMenuGenerationTool = forwardRef(
  ({ classes, renderButton, onChange, disabled, projectType }, ref) => {
    const styles = useStyles({ classes });

    const menuItems = useMemo(() => {
      const toolOptions = getSectionToolsOptions({
        projectType,
        withFreeStyle: true,
      });

      const createClickHandler = (tool) => (event) => {
        event.stopPropagation();
        onChange(tool);
      };

      return toolOptions.map((option) => {
        if (option.tool) {
          return {
            id: option.tool,
            type: CUSTOM_MENU_ITEM_TYPE.default,
            label: getToolSectionLabel(option.tool),
            icon: isFreestyleGenerationTool(option.tool) ? (
              <IconGeneralText className={styles.iconTool} />
            ) : (
              <GenerationToolIcon
                className={styles.iconTool}
                tool={option.tool}
              />
            ),
            onClick: createClickHandler(option.tool),
          };
        } else {
          return {
            id: option.subheader,
            type: CUSTOM_MENU_ITEM_TYPE.subheader,
            label: option.subheader,
          };
        }
      });
    }, [onChange, projectType, styles.iconTool]);

    return (
      <ContextMenu
        classes={{ menuRoot: styles.menuRoot }}
        ref={ref}
        renderButton={renderButton}
        items={menuItems}
        menuProps={{
          ...MENU_PROPS,
          PopoverClasses: { root: styles.menuWrapper },
        }}
        disabled={disabled}
      />
    );
  }
);

ContextMenuGenerationTool.propTypes = {
  classes: PropTypes.shape({}),
  renderButton: PropTypes.func,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  projectType: PropTypes.string,
};

ContextMenuGenerationTool.defaultProps = {
  classes: null,
  renderButton: null,
  onChange: null,
  disabled: false,
  projectType: null,
};
